import { render, staticRenderFns } from "./EventItemList.vue?vue&type=template&id=8bbc330a&scoped=true"
import script from "./EventItemList.vue?vue&type=script&lang=js"
export * from "./EventItemList.vue?vue&type=script&lang=js"
import style0 from "./EventItemList.vue?vue&type=style&index=0&id=8bbc330a&prod&scoped=true&lang=css"
import style1 from "./EventItemList.vue?vue&type=style&index=1&id=8bbc330a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbc330a",
  null
  
)

export default component.exports